import { createApp } from 'vue';
import App from './App.vue';

// Array.from polyfill for IE
if (!Array.from) {
  Array.from = function (arrayLike) {
    return Array.prototype.slice.apply(arrayLike);
  }
}

// Nodelist.prototype.forEach polyfill for IE.
if (!NodeList.prototype.forEach) {
  NodeList.prototype.forEach = function (callback) {
    var self = this;

    // Trick it into an array.
    Array.from(self).forEach(function (elem, i) {
      callback.call(self, elem, i, self);
    });
  }
}

document.querySelectorAll('*[data-vue-app="exhibit_frame"]').forEach(function (element) {
  createApp(App, {'data-element': element, 'data-data': JSON.parse(element.dataset.vueAppData)}).mount(element);
});

/*
(function () {
  let prev = null;

  function _anim () {
      if (prev !== document.activeElement) {
          console.log(prev = document.activeElement);
      }
      window.requestAnimationFrame(_anim);
  }

  window.requestAnimationFrame(_anim);
})();
*/
